export const navbarItems = [
    {
     title: "Menu",
     submenu: [
        {
            title: "Home",
            link: "/#",
           },
           {
            title: "About",
            link: "aboutme",
           },
           {
            title: "Experience",
            link: "experience",
           },
           {
            title: "Technologies",
            link: "technologies",
           },
           {
            title: "Contact",
            link: "contact",
           }
          ]
         }
];
